import { css } from 'styled-components';
import tw from 'tailwind.macro';

export const CellStyle = css`
  ${tw`p-small flex justify-center`}
  width:111px;
  height: 103px;
`;
